import dynamic from 'next/dynamic';

import { ChakraProvider } from '@chakra-ui/react';
import {
  CarbonClickGlobal,
  CarbonClickTheme,
} from '../../business-emissions/CarbonClickTheme/CarbonClick.Theme';

const App = dynamic(() => import('../../business-emissions/App'), {
  ssr: false, // we use clientside localStorage for routing, so SSR is pointless and confuses React
});

const Index = () => (
  <ChakraProvider theme={CarbonClickTheme}>
    <CarbonClickGlobal />
    <App />
  </ChakraProvider>
);

export default Index;
